import { getLocale } from '../storage/LocaleManager';
import { GS_USER_REGION_MAP } from './region';
const region = process.env.REACT_APP_REGION || '';
export const CLOUD_MSNA = 'CloudMSNA';
export const CLOUD_MSCU = 'CloudMSCU';
export const CLOUD_TBPR = 'CloudTBPR';

/**
 * 检测操作系统类型 - write by cursor
 */
export function detectOS(): string {
  // 检查是否在浏览器环境中
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return 'unknown';
  }

  const userAgent = navigator.userAgent;

  if (userAgent.indexOf('Windows NT') > -1) {
    return 'Windows';
  } else if (userAgent.indexOf('Mac OS X') > -1) {
    return 'Mac OS X';
  } else if (userAgent.indexOf('Linux') > -1) {
    return 'Linux';
  } else if (userAgent.indexOf('Android') > -1) {
    return 'Android';
  } else if (userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1) {
    return 'iOS';
  }

  return 'unknown';
}

/**
 * 检测浏览器类型 - write by cursor
 */
export function detectBrowser(): string {
  // 检查是否在浏览器环境中
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return 'unknown';
  }

  const userAgent = navigator.userAgent;

  if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Edg') === -1) {
    return 'Chrome';
  } else if (userAgent.indexOf('Firefox') > -1) {
    return 'Firefox';
  } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
    return 'Safari';
  } else if (userAgent.indexOf('Edg') > -1) {
    return 'Edge';
  } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
    return 'Opera';
  }

  return 'unknown';
}

// header携带头
export const GS_USER_AGENT_MAP = {
    'us': CLOUD_MSNA,
    'eu': CLOUD_MSCU,
};



// 根据region的结果header，包含os和browser信息 - write by cursor
const baseAgent = GS_USER_AGENT_MAP[region as keyof typeof GS_USER_AGENT_MAP] || CLOUD_TBPR;
const os = detectOS();
const browser = detectBrowser();
const maintenceRegion = localStorage.getItem(`maintence_region`) || '';
export const GS_USER_AGENT = `${baseAgent}; os=${os}; browser=${browser}; locale=${getLocale()}`;
export const GS_USER_REGION = GS_USER_REGION_MAP[maintenceRegion as keyof typeof GS_USER_REGION_MAP] || '';
